///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.reporting = modules.ribit.reporting || {};
modules.ribit.reporting.plugins = modules.ribit.reporting.plugins || {};
modules.ribit.reporting.plugins.datepicker = modules.ribit.reporting.plugins.datepicker || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.reporting.plugins.datepicker = {

    /**
     * Configure the rule's display and behavior
     */
    initRule: function (rule) {
        rule.$el.find('.rule-value-container input').datepicker('update');
    },
};
